// React
import React, { Fragment } from 'react';

// Components
import KYCLevelComponent from '@alphapoint/apex-web/lib/components/KYC/KYCLevel';
import KYCSumSubModal from './KYCSumSubModal';

// Utils
import { getSumSubLevelVerificationProps } from '@alphapoint/apex-web/lib/components/KYC/kycLevelsVerificationPropsHelper';

import './KYCSumSubComponent.css';

class KYCSumSubLevelsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      showIFrame: false,
    };
  }

  onSumSubClick = () => {
    this.setState({
      showIFrame: true,
    });
  };

  onCloseSumSub = () => {
    this.setState({
      showIFrame: false,
    });
  };

  render() {
    const { highlightStyle, level1, level2, level3, level4, levelIncreaseStatus, verificationLevel } = this.props;
    return (
      <Fragment>
        {this.state.error && <p className="kyc-sumsub__error">{this.state.error}</p>}
        {[level1, level2, level3, level4].map((level) => {
          if (!level) return null; // Skip if level is falsy
          const props = getSumSubLevelVerificationProps(verificationLevel, level.level, levelIncreaseStatus);
          return (
            <KYCLevelComponent
              key={level.level}
              config={level}
              {...props}
              highlightStyle={highlightStyle}
              onSumSubClick={this.onSumSubClick}
            />
          );
        })}
        <KYCSumSubModal isOpen={this.state.showIFrame} onCancel={this.onCloseSumSub} />
      </Fragment>
    );
  }
}

export default KYCSumSubLevelsComponent;
